var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonIdealSaleReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#paint0_radial_7252_94946)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7252_94946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7875 17.3628H52.8028C51.7199 17.3628 50.8649 18.2177 50.8649 19.3007C50.8649 20.3836 51.7199 21.2386 52.8028 21.2386H53.8858L43.4554 31.7259C43.1704 32.0109 42.6574 32.0109 42.3725 31.7259L37.3568 26.7102C36.5018 25.8553 35.3049 25.3423 34.051 25.3423C32.797 25.3423 31.6571 25.8553 30.7452 26.7102L19.8018 37.5966C19.0609 38.3375 19.0609 39.5915 19.8018 40.3894C20.1438 40.7314 20.6568 40.9594 21.1697 40.9594C21.6827 40.9594 22.1957 40.7314 22.5376 40.3894C33.196 29.7311 33.424 29.5031 33.424 29.4461C33.709 29.1611 34.2219 29.1611 34.5069 29.4461L39.8646 34.8037L39.9216 34.8607C40.7196 35.4877 41.8025 35.8867 42.8284 35.8867C44.0824 35.8867 45.2793 35.3737 46.1342 34.5188L56.7356 23.9174V25.3423C56.7356 26.4253 57.5905 27.2802 58.6735 27.2802C59.7564 27.2802 60.6114 26.4253 60.6114 25.3423V19.3007C60.7254 18.2177 59.8704 17.3628 58.7875 17.3628Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.114 32.9229C53.8291 32.9229 53.5441 33.0368 53.3161 33.2648C53.0881 33.4928 52.9741 33.7778 52.9741 34.0628V58.5713H50.8652V43.8662C50.8652 43.2392 50.3523 42.7833 49.7823 42.7833H44.4246H42.1448C41.8598 42.7833 41.5748 42.8973 41.3468 43.1252C41.1188 43.3532 41.0048 43.6382 41.0048 43.9232V58.5713H38.896V39.1925C38.896 38.5655 38.383 38.1095 37.813 38.1095H32.4553H30.1755C29.8905 38.1095 29.6055 38.2235 29.3775 38.4515C29.1495 38.6795 29.0355 38.9645 29.0355 39.2495V58.6283H26.8697V50.0788C26.8697 49.4519 26.3567 48.9959 25.7867 48.9959H20.3721H18.0922C17.8072 48.9959 17.5222 49.1099 17.2942 49.3379C17.0663 49.5659 16.9523 49.8508 16.9523 50.1358V58.6853H15.9833C15.3564 58.6853 14.9004 59.1983 14.9004 59.7682C14.9004 60.3952 15.4134 60.8512 15.9833 60.8512H63.8605C64.4874 60.8512 64.9434 60.3382 64.9434 59.7682C64.9434 59.1413 64.4304 58.6853 63.8605 58.6853H62.8915V34.1768C62.8915 33.5498 62.3785 33.0938 61.8086 33.0938L54.114 32.9229Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0461 58.5144H18.6055V51.2188C18.6055 50.7059 19.0044 50.3069 19.5174 50.3069H24.1911C24.7041 50.3069 25.1031 50.7059 25.1031 51.2188V58.5144H25.0461Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2125 58.5143H42.7148V45.5191C42.7148 45.0062 43.1138 44.6072 43.6268 44.6072H48.3005C48.8135 44.6072 49.2125 45.0062 49.2125 45.5191V58.5143Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1867 58.5142H30.7461V40.6173C30.7461 40.1043 31.1451 39.7053 31.658 39.7053H36.3318C36.8447 39.7053 37.2437 40.1043 37.2437 40.6173V58.5142H37.1867Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1828 58.5142H54.7422V35.4876C54.7422 34.9747 55.1412 34.5757 55.6541 34.5757H60.3279C60.8408 34.5757 61.2398 34.9747 61.2398 35.4876V58.5142H61.1828Z",
    fill: "#AEB5BE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7252_94946",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 7) rotate(66.1979) scale(79.7862)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7252_94946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.1,
    height: 43.3744,
    fill: "white",
    transform: "translate(14.9004 17.3628)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonIdealSaleReport);
export default __webpack_public_path__ + "static/media/NonIdealSaleReport.13e64d4117f3702c4d43e1a395199963.svg";
export { ForwardRef as ReactComponent };